import React, { Component } from 'react';

//redux
import { connect } from "react-redux";

//路由
import {
    BrowserRouter,
    Route
} from "react-router-dom";

import { Spin } from "antd";

//组件
import Main from './main'
import VideoPlayer from './components/VideoPlayer'
import Login from './common/Login'
import WagesSubmitSucceed from './common/WagesSubmitSucceed'
import CreationDetail from './components/CreationDetail'
import ActivityList from "./common/ActivityList";
import WxLogin from "./common/WxLogin";
import Iframe from "./components/Iframe";
import Answer from "./common/html/answer"

//子组件


let { innerHeight, innerWidth } = window
class Routers extends Component {

    render() {
        return (
            <>
                {
                    this.props.routerloading === 0 ?
                        <div style={{ width: '100%', height: innerHeight + 'px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', left: 0, top: 0 }}>
                            <Spin tip="加载中.." style={{ zIndex: 9999 }} />
                        </div>
                        :
                        null
                }
                <BrowserRouter>
                     {/*<Header history={this.props.history} />*/}
                    {/*此处注册全局路由 */}
                    <Route path='/' exact component={ActivityList}></Route>
                    <Route path='/videoPlay' exact component={VideoPlayer}></Route>
                    <Route path='/submitSucceed' exact component={WagesSubmitSucceed}></Route>
                    <Route path='/login' exact component={Login}></Route>
                    <Route path='/creationDetail/:creationId' exact component={CreationDetail}></Route>
                    <Route path='/iframe/:url' exact component={Iframe}></Route>
                    <Route path='/main/:activityId' exact component={Main}></Route>
                    <Route path='/main/:activityId/:select' exact component={Main}></Route>
                    <Route path='/html/answer' exact component={Answer}></Route>
                    <Route path='/wxLogin' exact component={WxLogin}></Route>


                </BrowserRouter>



            </>
        );
    }
}
const mapState = state => {
    let routerloading = state.getIn(['router', 'routerloading'])
    return {
        routerloading
    }
}
export default connect(mapState, null)(Routers)
